/**
 * Action/Notification trigger enum
 */
export enum NotificationActionEnum {
  /**
   * New task comment
   */
  TASK_COMMENT = 'TASK_COMMENT',
  /**
   * Task status update
   */
  TASK_STATUS = 'TASK_STATUS',
  /**
   * New task created
   */
  TASK_CREATE = 'TASK_CREATE',
  /** Task underpayment notification */
  TASK_UNDERPAYMENT = 'TASK_UNDERPAYMENT',
  /**
   * New project comment
   */
  PROJECT_COMMENT = 'PROJECT_COMMENT',
  /**
   * Project status update
   */
  PROJECT_STATUS = 'PROJECT_STATUS',
  /**
   * Project checklist update
   */
  PROJECT_CHECKLIST = 'PROJECT_CHECKLIST',
  /**
   * Someone from the project participants applied for a change in the deadline
   */
  PERSONAL_DEADLINE_DELAY_REQUEST = 'PERSONAL_DEADLINE_DELAY_REQUEST',
  /**
   * Personal project checklist reminder
   */
  PERSONAL_PROJECT_CHECKLIST_REMINDER = 'PERSONAL_PROJECT_CHECKLIST_REMINDER',
  /**
   * Personal project reminder
   */
  PERSONAL_PROJECT_REMINDER = 'PERSONAL_PROJECT_REMINDER',
  /** Personal project workflow event */
  PERSONAL_PROJECT_WORKFLOW = 'PERSONAL_PROJECT_WORKFLOW',
  /**
   * Personal task reminder
   */
  PERSONAL_TASK_REMINDER = 'PERSONAL_TASK_REMINDER',
  /**
   * New personal telegram message
   */
  PERSONAL_TELEGRAM = 'PERSONAL_TELEGRAM',
  /** Personal message about under construction */
  PERSONAL_SYSTEM_MESSAGE = 'PERSONAL_SYSTEM_MESSAGE',
  /**
   * New personal CRM message (comment with @user link)
   */
  PERSONAL_MESSAGE = 'PERSONAL_MESSAGE',
  /** Cash gap detected during payment calendar recalculation */
  PERSONAL_TASK_CASH_GAP_DETECTED = 'PERSONAL_TASK_CASH_GAP_DETECTED',
  /** Income plan not met (detecting durint payment calendar recalculation) */
  PERSONAL_TASK_INCOME_PLAN_NOT_MET = 'PERSONAL_TASK_INCOME_PLAN_NOT_MET',
  /** Deal personal reminder (for reminder creator) */
  PERSONAL_DEAL_REMINDER = 'PERSONAL_DEAL_REMINDER',
  /** Deal event personal reminder (for responsible users) */
  PERSONAL_DEAL_EVENT_REMINDER = 'PERSONAL_DEAL_EVENT_REMINDER',
  /** Changelog created */
  PERSONAL_CHANGELOG_CREATED = 'PERSONAL_CHANGELOG_CREATED',
  /** Helpdeskt task reminder (for reminder creator) */
  PERSONAL_HELPDESK_REMINDER = 'PERSONAL_HELPDESK_REMINDER',
  /** Export task complete */
  PERSONAL_EXPORT_TASK_COMPLETE = 'PERSONAL_EXPORT_TASK_COMPLETE',
  /**
   * Variance alert
   */
  VARIANCE_ALERT = 'VARIANCE_ALERT',
  /**
   * New helpdesk task
   */
  HD_TASK_CREATE = 'HD_TASK_CREATE',
  /**
   * Helpdesk task status change
   */
  HD_TASK_STATUS = 'HD_TASK_STATUS',
  /**
   * Helpdesk task comment
   */
  HD_TASK_COMMENT = 'HD_TASK_COMMENT',
  /**
   * Helpdesk task updated
   */
  HD_TASK_UPDATED = 'HD_TASK_UPDATED',
  /**
   * Helpdesk task "waiting for answer" notifications
   */
  HD_TASK_WAITING_FOR_ANSWER = 'HD_TASK_WAITING_FOR_ANSWER',
  /** New mailing template was created */
  MAILING_TEMPLATE_CREATED = 'MAILING_TEMPLATE_CREATED',
  /** Mailing created */
  MAILING_CREATED = 'MAILING_CREATED',
  /** Mailing launched */
  MAILING_LAUNCHED = 'MAILING_LAUNCHED',
  /** Mailing finished */
  MAILING_FINISHED = 'MAILING_FINISHED',
  /** New deal was created */
  DEAL_CREATED = 'DEAL_CREATED',
  /** Deal status changed */
  DEAL_STATUS_CHANGED = 'DEAL_STATUS_CHANGED',
  /** Deal was deleted */
  DEAL_DELETED = 'DEAL_DELETED',
  /** Deal was restored */
  DEAL_RESTORED = 'DEAL_RESTORED',
  /** New commentary on deal */
  DEAL_COMMENT = 'DEAL_COMMENT',
  /** Deal event message */
  DEAL_EVENT = 'DEAL_EVENT',
  /** New deal was created */
  DEALS_GROUP_CREATED = 'DEALS_GROUP_CREATED',
  /** Deal status changed */
  DEALS_GROUP_STATUS_CHANGED = 'DEALS_GROUP_STATUS_CHANGED',
  /** Deal was deleted */
  DEALS_GROUP_DELETED = 'DEALS_GROUP_DELETED',
  /** Deal was restored */
  DEALS_GROUP_RESTORED = 'DEALS_GROUP_RESTORED',
  /** New commentary on deals group */
  DEALS_GROUP_COMMENT = 'DEALS_GROUP_COMMENT',
  /** New budget request created */
  BUDGET_REQUEST_CREATED = 'BUDGET_REQUEST_CREATED',
  /** Budget request status changed */
  BUDGET_REQUEST_STATUS_CHANGED = 'BUDGET_REQUEST_STATUS_CHANGED',
  /** Budget request comment added */
  BUDGET_REQUEST_COMMENT = 'BUDGET_REQUEST_COMMENT',
  /** Transit task updated */
  TRANSIT_TASK_UPDATED = 'TRANSIT_TASK_UPDATED',
  /** Transit task comment added */
  TRANSIT_TASK_COMMENT = 'TRANSIT_TASK_COMMENT',
  /** Hikvision camera unknown event */
  HIKVISION_CAMERA_UNKNOWN_EVENT = 'HIKVISION_CAMERA_UNKNOWN_EVENT',

  // Debt collection task notifications
  DEBT_COLLECTION_TASK_COMMENT = 'DEBT_COLLECTION_TASK_COMMENT',
  /** Debt collection task status changed */
  DEBT_COLLECTION_TASK_STATUS = 'DEBT_COLLECTION_TASK_STATUS',
  /** Debt collection task date changed */
  DEBT_COLLECTION_TASK_DATE = 'DEBT_COLLECTION_TASK_DATE',
  /** Debt collection task event status changed */
  DEBT_COLLECTION_TASK_EVENT_STATUS = 'DEBT_COLLECTION_TASK_EVENT_STATUS',
  /** Debt collection task event rescheduled */
  DEBT_COLLECTION_TASK_EVENT_RESCHEDULE = 'DEBT_COLLECTION_TASK_EVENT_RESCHEDULE',
  /** Debt collection task personal reminder */
  PERSONAL_DEBT_COLLECTION_TASK_REMINDER = 'PERSONAL_DEBT_COLLECTION_TASK_REMINDER',
  /** Debt collection task personal reminder */
  PERSONAL_DEBT_COLLECTION_TASK_EVENT_REMINDER = 'PERSONAL_DEBT_COLLECTION_TASK_EVENT_REMINDER',
  /** Access card updated */
  ACCESS_CARD_UPDATED = 'ACCESS_CARD_UPDATED',

  // Planned income notifications
  /** Planned income date arrived */
  PLANNED_INCOME_DATE_ARRIVED = 'PLANNED_INCOME_DATE_ARRIVED',
  /** Planned income was paid */
  PLANNED_INCOME_PAID = 'PLANNED_INCOME_PAID',
  /** New commentary on planned income */
  PLANNED_INCOME_COMMENT = 'PLANNED_INCOME_COMMENT',
}
